module.exports = __webpack_public_path__ + "img/baseline_explanation.5a2db7e9.png";